import React from "react";
import { Link } from "react-router-dom";
import { Badge } from "@teals/ui-web";
import type { ApiIntegration } from "../../store/api/apiIntegrationsApi";
import { apiHost } from "../../store/api/apiIntegrationsApi";
import {
  DSCard,
  CardHeader,
  CardTitle,
  CardRecords,
  AgentChipRow,
  AgentChip,
  CardFooter,
  MetaItem,
  MetaItemGrow,
  DividerDot,
} from "../DataSources/styles";

interface ApiIntegrationCardProps {
  api: ApiIntegration;
  to: string;
  agentNames?: Record<string, string>;
}

const ApiIntegrationCard: React.FC<ApiIntegrationCardProps> = ({
  api,
  to,
  agentNames = {},
}) => {
  const agentChips = (api.agentIds || []).map((id) => ({
    id,
    label: agentNames[id] || id,
  }));
  const keyLabel =
    api.credentialSource === "org" ? "Your key" : "Shared demo key";
  const host = api.host || apiHost(api.baseUrl) || "No host";
  const placement = api.auth?.placements?.[0];
  const placementLabel = placement
    ? `${placement.in} ${placement.name}`
    : "No placement";

  return (
    <Link to={to}>
      <DSCard padding={20} elevation="sm" data-testid="api-integration-card">
        <CardHeader>
          <div>
            <CardTitle>{api.name}</CardTitle>
            <CardRecords>{host}</CardRecords>
          </div>
          <Badge variant="info" size="sm">
            API
          </Badge>
        </CardHeader>
        {agentChips.length > 0 && (
          <AgentChipRow>
            {agentChips.slice(0, 4).map((chip) => (
              <AgentChip key={chip.id}>{chip.label}</AgentChip>
            ))}
          </AgentChipRow>
        )}
        <CardFooter>
          <MetaItemGrow title={keyLabel}>{keyLabel}</MetaItemGrow>
          <DividerDot />
          <MetaItem>{placementLabel}</MetaItem>
          <DividerDot />
          <MetaItem>Open →</MetaItem>
        </CardFooter>
      </DSCard>
    </Link>
  );
};

export default ApiIntegrationCard;
